import { render, staticRenderFns } from "./NumberInputCommon.vue?vue&type=template&id=2837a3cf&"
import script from "./NumberInputCommon.vue?vue&type=script&lang=js&"
export * from "./NumberInputCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports